export function formatCurrency(value, currency = 'INR') {
  if (value === null || value === undefined || value === '') return '-';
  // Indian numbering (lakhs/crores) for INR; otherwise locale-appropriate
  const locale = currency === 'INR' ? 'en-IN'
    : currency === 'GBP' ? 'en-GB'
    : currency === 'EUR' ? 'de-DE'
    : 'en-US';
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency', currency,
      minimumFractionDigits: 0, maximumFractionDigits: 0,
    }).format(Number(value));
  } catch {
    return `${currency} ${value}`;
  }
}

// Convenience — always INR with Indian formatting (₹1,42,500).
// Use this everywhere the value is known to be in INR.
export function formatINR(value) {
  return formatCurrency(value, 'INR');
}

export function formatNumber(value) {
  if (value === null || value === undefined || value === '') return '-';
  return new Intl.NumberFormat('en-IN').format(Number(value));
}

export function formatDate(dateStr) {
  if (!dateStr) return '-';
  try {
    return new Date(dateStr).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  } catch { return dateStr; }
}

export function formatDateShort(dateStr) {
  if (!dateStr) return '-';
  try { return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); } catch { return dateStr; }
}

export function daysUntil(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  const now = new Date();
  return Math.ceil((d - now) / (1000 * 60 * 60 * 24));
}

export function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}

export const STATUS_COLORS = {
  DRAFT: 'bg-gray-500/20 text-gray-400 border-gray-500/30',
  NEGOTIATION: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
  AWAITING_EXECUTION: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
  ACTIVE: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
  SUSPENDED: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
  UNDER_DISPUTE: 'bg-red-500/20 text-red-400 border-red-500/30',
  PRACTICAL_COMPLETION: 'bg-teal-500/20 text-teal-400 border-teal-500/30',
  DEFECTS_LIABILITY: 'bg-purple-500/20 text-purple-400 border-purple-500/30',
  CLOSED: 'bg-zinc-500/20 text-zinc-400 border-zinc-500/30',
  TERMINATED: 'bg-red-600/20 text-red-500 border-red-600/30',
};

export const CLAIM_STAGE_COLORS = {
  IDENTIFIED: 'bg-gray-500/20 text-gray-400',
  NOTIFIED: 'bg-[#1E4E8C]/20 text-[#1E4E8C]',
  SUBSTANTIATING: 'bg-blue-500/20 text-blue-400',
  UNDER_ASSESSMENT: 'bg-amber-500/20 text-amber-400',
  NEGOTIATING: 'bg-orange-500/20 text-orange-400',
  DETERMINATION: 'bg-purple-500/20 text-purple-400',
  SETTLEMENT: 'bg-emerald-500/20 text-emerald-400',
  CLOSED: 'bg-zinc-500/20 text-zinc-400',
};

export const VO_STATUS_COLORS = {
  CR_RAISED: 'bg-gray-500/20 text-gray-400',
  QUOTATION_REQUESTED: 'bg-[#1E4E8C]/20 text-[#1E4E8C]',
  QUOTED: 'bg-blue-500/20 text-blue-400',
  UNDER_REVIEW: 'bg-amber-500/20 text-amber-400',
  APPROVED: 'bg-emerald-500/20 text-emerald-400',
  REJECTED: 'bg-red-500/20 text-red-400',
  IMPLEMENTED: 'bg-teal-500/20 text-teal-400',
  CLOSED: 'bg-zinc-500/20 text-zinc-400',
};
